import { css } from "@emotion/react";

export const root = css`
  display: grid;
  row-gap: 12px;
`;

export const variantStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const variantCardStyle = css`
  border-width: 1px;
  display: grid;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  padding: 12px 4px;
  white-space: nowrap;
`;

export const hiddenInputStyle = css`
  display: none;
`;

export const notSelectedVariantCardStyle = css`
  background-color: #fff;
  border-color: #a3a3a3;
  border-style: solid;
  cursor: pointer;
`;

export const selectedVariantCardStyle = css`
  background-color: #f5f5f5;
  border-color: #000;
  box-shadow: inset 0 0 0 1px #000;
  border-style: solid;
  pointer-events: none;
`;

export const soldOutVariantCardStyle = css`
  border-color: rgba(0, 0, 0, 0.08);
  border-style: dashed;
  pointer-events: none;
`;
